"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseBitcoinSigner = void 0;
var sign_transaction_1 = require("./sign-transaction");
Object.defineProperty(exports, "BaseBitcoinSigner", { enumerable: true, get: function () { return __importDefault(sign_transaction_1).default; } });
//# sourceMappingURL=index.js.map